import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CvvCardPage } from './cvv-card.page';

const routes: Routes = [
  {
    path: '',
    component: CvvCardPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CvvCardPageRoutingModule {}
